import { produce } from 'immer';

const INITIAL_STATE = {
  documents: null,
  total: 0,
  loading: false,
  history: null,
  historyLoading: false,
};

export default function renotarizationLogs(state = INITIAL_STATE, action) {
  return produce(state, (draft) => {
    switch (action.type) {
      case '@renotarizationLogs/GET_REQUEST': {
        draft.loading = true;
        break;
      }
      case '@renotarizationLogs/GET_SUCCESS': {
        draft.documents = action.payload.data.content;
        draft.total = action.payload.data.total;
        draft.loading = false;
        break;
      }
      case '@renotarizationLogs/GET_HISTORY_REQUEST': {
        draft.historyLoading = true;
        draft.history = null;
        break;
      }
      case '@renotarizationLogs/GET_HISTORY_SUCCESS': {
        draft.history = action.payload.history;
        draft.historyLoading = false;
        break;
      }
      case '@renotarizationLogs/FAILURE': {
        draft.loading = false;
        draft.historyLoading = false;
        break;
      }
      default:
    }
  });
}
